<template>
<div class="nb-modal-scrollable">
    <div id="mymodal" class="container nb-modal-scrollable-container">
        <div class="nb-modal-scrollable-body">
            <div>
                <bar-manut 
                    :single-entity="this.modalTitle" 
                    :crud="this.crud"
                    :title="this.modalTitle"
                    @closeform="closeForm" 
                    @save="handleSave">
                </bar-manut>
                <br>
                <div class="row">
                    <div class="col-md-9">
                        <!-- MENSAGENS DE VALIDACAO -->
                        <validation v-if="errmessages.errmessages" title="Erros de Validação" :messages="errmessages.errmessages"></validation>
                        <!-- FIM MENSAGENS DE VALIDACAO -->
                        <div class="row">
                            <form-field ref="origem" v-model="movimento.origem.codcta" type="select2" col="6" label="Conta Origem" :metadata="metadata.fin.codcta"
                                parent="mymodal" name="codctaorigem" :v-errors="errors" v-validate="metadata.fin.codcta.validator"></form-field>
                        </div>
                        <div class="row">
                            <form-field v-model="movimento.destino.codcta" type="select2" col="6" label="Conta Destino" :metadata="metadata.fin.codcta"
                                parent="mymodal" name="codctadestino" :v-errors="errors" v-validate="metadata.fin.codcta.validator"></form-field>
                        </div>
                        <div class="row">
                            <form-field v-model="movimento.data" type="date" col="3" :metadata="metadata.fin.data"
                                name="data" :v-errors="errors" v-validate="metadata.fin.data.validator"></form-field>                            
                            <form-field v-model="movimento.valor" type="value" col="3" :metadata="metadata.fin.vlr" 
                                name="vlr" :v-errors="errors" v-validate="metadata.fin.vlr.validator"></form-field>
                            <!-- <form-field v-model="movimento.float" type="value" col="2" label="Float"
                                name="float" :v-errors="errors" v-validate="{ max: 2 }"></form-field>                             -->
                        </div>
                        <div class="row mb-5">
                            <form-field v-model="movimento.origem.codnatfin" type="select2" col="6" label="Natureza Origem" :metadata="metadata.fin.codnatfin"
                                parent="mymodal" name="codnatfinorigem" :select2="{entity: 'natfin/despesas', minlength: 0}" :v-errors="errors" v-validate="metadata.fin.codnatfin.validator"></form-field>
                            <form-field v-model="movimento.destino.codnatfin" type="select2" col="6" label="Natureza Destino" :metadata="metadata.fin.codnatfin"
                                parent="mymodal" name="codnatfindestino" :select2="{entity: 'natfin/receitas', minlength: 0}" :v-errors="errors" v-validate="metadata.fin.codnatfin.validator"></form-field>
                        </div>                        
                    </div>                    
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            fin: {...this.$store.getters.getEntities.fin},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            modalTitle: 'TRANSFERÊNCIA',
            movimento: {
                origem: {
                    codcta: null,
                    codnatfin: null,
                },
                destino: {
                    codcta: null,
                    codnatfin: null,
                },
                valor: null,
                float: 0,
                data: null,
                transferencia: true,
            }
        }
    },

    computed: {

    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            if (this.crud == SysVars.crudI) {
                this.movimento.data = this.$getDate()
                return
            }

            await this.$store.dispatch('loadFin', { id: this.index })

            if (this.$store.getters.getFin) {
                this.fin = {...this.$store.getters.getFin}
            }

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiPost () {
            //efetua a gravacao
            var modulo = '/fin/movimento/'
            var sendData = {}
            sendData = { fin: this.movimento }

            let metodo = 'post'

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)

            if (data.errmessages) {
                this.errmessages = data.errmessages
                this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                this.$erpToastInserted()
                this.errmessages = {}
                this.closeForm()
            }
        },

    },

    components: {

    },

    watch: {

    },

    beforeCreate () {

    },

    mounted () {
        this.$nextTick(function () {
          this.$refs.origem.focus()
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        this.loadData() 
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/forms/financeiro-transf-form.vue